export default __webpack_public_path__ + "static/media/about-story.3da20457.jpg";